export const es = {
  htmlLang: 'es',
  switchLabel: 'Leer en inglés',
  topbar: {
    status: 'En desarrollo',
    subtitle: 'Investigación abierta · Actualizaciones continuas',
    place: 'Miami, Florida',
  },
  brand: {
    kicker: 'Periodismo de investigación',
    title: 'LA RED DEL',
    titleAccent: 'DORAL',
  },
  nav: {
    case: 'El caso',
    pattern: 'El patrón',
    org: 'La organización',
    method: 'El método',
    timeline: 'Línea de tiempo',
    contact: 'Contacto',
  },
  menu: { open: 'Abrir menú', close: 'Cerrar menú', sections: 'Secciones de la investigación' },
  hero: {
    badge: 'Investigación en curso',
    headline: 'El taller de lujo que esconde una organización mucho más grande',
    ledeStart:
      'Desde hace años, Esteban Jimenez es considerado uno de los mecánicos más prestigiosos de Miami, Florida. Su taller, ',
    ledeShop: 'Esteem Custom',
    ledeEnd:
      ', aparece constantemente en redes sociales mostrando vehículos de lujo, modificaciones exclusivas y una imagen de éxito absoluto.',
    metaPlace: 'Miami, Florida',
    metaFile: 'Expediente abierto',
    metaStatus: 'Actualizándose',
    asideTitle: 'Lo que sabemos',
    asideLabel: 'Resumen del caso',
    asideLines: [
      'Clientes satisfechos. Autos deportivos. Celebridades. Una reputación aparentemente impecable.',
      'Al menos, eso era lo que todos veían.',
      'Lo que nadie imaginaba era que, detrás del brillo de las fotografías, existía una organización mucho más grande.',
    ],
  },
  chapterLabel: 'Capítulo',
  ch1: {
    title: 'El comienzo',
    p1: 'Todo comenzó con una simple denuncia. Un cliente aseguró que había pagado más de 40.000 dólares por la restauración completa de un automóvil clásico.',
    p2: 'El trabajo nunca terminó. El vehículo desapareció durante meses. Las llamadas dejaron de responderse.',
    p3: 'Cuando finalmente recuperó el automóvil, muchas de las piezas originales habían sido reemplazadas por componentes usados.',
    pull: 'Parecía un caso aislado. No lo era.',
  },
  ch2: {
    title: 'Un patrón',
    p1: 'Con el paso de los meses comenzaron a aparecer más testimonios. Siempre ocurría lo mismo.',
    items: [
      'Promesas imposibles',
      'Adelantos elevados',
      'Retrasos constantes',
      'Cambios de versión',
      'Facturas difíciles de entender',
      'Silencio ante la insistencia',
    ],
    p2: 'Y cuando los clientes insistían demasiado… simplemente dejaban de recibir respuestas.',
  },
  ch3: {
    title: 'Algo no cerraba',
    p1: 'Una persona que fue estafada de manera independiente decidió comenzar a investigar. Lo primero que descubrió fue que varias empresas aparentemente distintas compartían información sorprendentemente similar.',
    items: [
      'Direcciones repetidas',
      'Números telefónicos compartidos',
      'Personas relacionadas entre sí',
      'Empleados en varias compañías a la vez',
    ],
    pull: 'Era como si todos formaran parte del mismo rompecabezas.',
  },
  ch4: {
    title: 'La organización',
    p1: 'Con el tiempo aparecieron nuevas piezas.',
    items: [
      'Empresas creadas y cerradas en pocos meses',
      'Negocios que cambiaban de nombre',
      'Sociedades registradas por terceros',
      'Vehículos vendidos varias veces',
      'Clientes provenientes de distintos estados',
    ],
    p2: 'Todo parecía diseñado para dificultar cualquier reclamo.',
  },
  ch5: {
    title: 'El método',
    p1: 'Según la investigación, la organización seguía siempre el mismo esquema:',
    steps: [
      { title: 'Construir prestigio', text: 'Una imagen pública impecable, sostenida por redes sociales y reputación.' },
      { title: 'Exhibir el lujo', text: 'Autos de alta gama y proyectos impresionantes como carta de presentación.' },
      { title: 'Ganar la confianza', text: 'Trato cercano, referencias cruzadas y promesas imposibles de cumplir.' },
      { title: 'Solicitar adelantos', text: 'Grandes pagos por anticipado antes de iniciar cualquier trabajo real.' },
      { title: 'Retrasar el trabajo', text: 'Demoras indefinidas, cambios de versión y facturas difíciles de entender.' },
      { title: 'Trasladar la culpa', text: 'Cuando aparecen las denuncias, la responsabilidad recae en un tercero.' },
    ],
    pull: 'Un sistema tan simple como efectivo.',
  },
  ch6: {
    title: 'Lo que viene',
    p1: 'Una línea de tiempo que muestra cómo, supuestamente, funcionaba toda la organización. Porque a veces la mejor manera de entender cómo opera una estafa es a través de una historia.',
  },
  timelineStage: 'Fase',
  timeline: [
    { title: 'La vitrina', text: 'El taller construye una reputación pública impecable: vehículos de lujo, celebridades y una presencia constante en redes sociales.' },
    { title: 'El primer encargo', text: 'Un cliente entrega más de 40.000 dólares por la restauración completa de un automóvil clásico. El trabajo nunca termina.' },
    { title: 'El silencio', text: 'El vehículo desaparece durante meses. Las llamadas dejan de responderse. Al recuperarlo, varias piezas originales fueron reemplazadas por componentes usados.' },
    { title: 'El patrón', text: 'Con el paso de los meses aparecen más testimonios. Siempre la misma secuencia: promesas, adelantos, retrasos y facturas confusas.' },
    { title: 'Las coincidencias', text: 'Empresas aparentemente distintas comparten direcciones, teléfonos, personas relacionadas e incluso empleados en común.' },
    { title: 'La estructura', text: 'Sociedades registradas por terceros, negocios que cambian de nombre, empresas abiertas y cerradas en pocos meses, vehículos vendidos varias veces.' },
    { title: 'El bloqueo', text: 'Clientes de distintos estados. Todo parece diseñado para dificultar cualquier reclamo y diluir la responsabilidad.' },
  ],
  notice: {
    title: 'Aviso importante',
    text: 'Todo el contenido se está investigando. Estaremos publicando en este sitio las novedades y desenmascarando a estos delincuentes.',
  },
  footer: {
    about:
      'Un expediente abierto sobre presuntas estafas en el sector de restauración y modificación de vehículos en Miami, Florida.',
    testimonyTitle: '¿Tienes un testimonio?',
    testimonyText:
      'Si viviste una situación similar, tu caso puede ayudar a completar el rompecabezas. Los testimonios se tratan de forma confidencial.',
    testimonyCta: 'Enviar testimonio',
    sections: 'Secciones',
    links: ['El comienzo', 'Un patrón', 'La organización', 'El método', 'Línea de tiempo'],
    disclaimer: 'Toda la información publicada corresponde a una investigación en desarrollo.',
    rights: '© 2026 Periodismo para todos',
  },
}

export type Dictionary = typeof es

export const en: Dictionary = {
  htmlLang: 'en',
  switchLabel: 'Read in Spanish',
  topbar: {
    status: 'Developing',
    subtitle: 'Open investigation · Continuous updates',
    place: 'Miami, Florida',
  },
  brand: {
    kicker: 'Investigative journalism',
    title: 'THE DORAL',
    titleAccent: 'NETWORK',
  },
  nav: {
    case: 'The case',
    pattern: 'The pattern',
    org: 'The organization',
    method: 'The method',
    timeline: 'Timeline',
    contact: 'Contact',
  },
  menu: { open: 'Open menu', close: 'Close menu', sections: 'Investigation sections' },
  hero: {
    badge: 'Ongoing investigation',
    headline: 'The luxury shop hiding a far larger operation',
    ledeStart:
      'For years now, Esteban Jimenez has been considered one of the most prestigious mechanics in Miami, Florida. His shop, ',
    ledeShop: 'Esteem Custom',
    ledeEnd:
      ', appears constantly on social media showing luxury vehicles, exclusive modifications and an image of absolute success.',
    metaPlace: 'Miami, Florida',
    metaFile: 'Open file',
    metaStatus: 'Updating',
    asideTitle: 'What we know',
    asideLabel: 'Case summary',
    asideLines: [
      'Happy clients. Sports cars. Celebrities. A seemingly spotless reputation.',
      'At least, that is what everyone saw.',
      'What no one imagined was that, behind the shine of the photographs, there was a much larger operation.',
    ],
  },
  chapterLabel: 'Chapter',
  ch1: {
    title: 'The beginning',
    p1: 'It all started with a single complaint. A client said he had paid more than $40,000 for the complete restoration of a classic car.',
    p2: 'The work was never finished. The vehicle disappeared for months. The calls went unanswered.',
    p3: 'When he finally recovered the car, many of the original parts had been replaced with used components.',
    pull: 'It looked like an isolated case. It was not.',
  },
  ch2: {
    title: 'A pattern',
    p1: 'As the months went by, more testimonies began to appear. It was always the same.',
    items: [
      'Impossible promises',
      'Large deposits',
      'Constant delays',
      'Shifting versions of the story',
      'Invoices that are hard to understand',
      'Silence when clients push back',
    ],
    p2: 'And when clients insisted too much… they simply stopped getting answers.',
  },
  ch3: {
    title: 'Something did not add up',
    p1: 'A person who was independently defrauded decided to start investigating. The first thing he found was that several seemingly separate companies shared surprisingly similar information.',
    items: [
      'Repeated addresses',
      'Shared phone numbers',
      'People connected to one another',
      'Employees working for several companies at once',
    ],
    pull: 'It was as if they were all pieces of the same puzzle.',
  },
  ch4: {
    title: 'The organization',
    p1: 'Over time, new pieces surfaced.',
    items: [
      'Companies opened and closed within months',
      'Businesses that changed names',
      'Corporations registered by third parties',
      'Vehicles sold several times over',
      'Clients from different states',
    ],
    p2: 'Everything seemed designed to make any claim harder to pursue.',
  },
  ch5: {
    title: 'The method',
    p1: 'According to the investigation, the organization always followed the same playbook:',
    steps: [
      { title: 'Build prestige', text: 'A flawless public image, sustained by social media and reputation.' },
      { title: 'Display the luxury', text: 'High-end cars and impressive projects as a calling card.' },
      { title: 'Earn the trust', text: 'Personal treatment, cross references and promises impossible to keep.' },
      { title: 'Request deposits', text: 'Large advance payments before any real work begins.' },
      { title: 'Delay the work', text: 'Indefinite delays, shifting versions and confusing invoices.' },
      { title: 'Shift the blame', text: 'When complaints appear, responsibility falls on a third-party service.' },
    ],
    pull: 'A system as simple as it is effective.',
  },
  ch6: {
    title: 'What comes next',
    p1: 'A timeline showing how the whole operation allegedly worked. Because sometimes the best way to understand how a scam operates is through a story.',
  },
  timelineStage: 'Phase',
  timeline: [
    { title: 'The showcase', text: 'The shop builds a flawless public reputation: luxury vehicles, celebrities and a constant social media presence.' },
    { title: 'The first job', text: 'A client hands over more than $40,000 for the full restoration of a classic car. The work is never finished.' },
    { title: 'The silence', text: 'The vehicle disappears for months. Calls go unanswered. When recovered, several original parts had been replaced with used components.' },
    { title: 'The pattern', text: 'As months pass, more testimonies appear. Always the same sequence: promises, deposits, delays and confusing invoices.' },
    { title: 'The coincidences', text: 'Seemingly separate companies share addresses, phone numbers, related people and even the same employees.' },
    { title: 'The structure', text: 'Corporations registered by third parties, businesses changing names, companies opened and closed within months, vehicles sold several times.' },
    { title: 'The blockade', text: 'Clients from different states. Everything appears designed to make claims harder and to dilute responsibility.' },
  ],
  notice: {
    title: 'Important notice',
    text: 'All of this content is still under investigation. We will keep publishing updates on this site and exposing these criminals.',
  },
  footer: {
    about:
      'An open file on alleged fraud in the vehicle restoration and modification industry in Miami, Florida.',
    testimonyTitle: 'Do you have a testimony?',
    testimonyText:
      'If you went through something similar, your case can help complete the puzzle. All testimonies are treated confidentially.',
    testimonyCta: 'Send testimony',
    sections: 'Sections',
    links: ['The beginning', 'A pattern', 'The organization', 'The method', 'Timeline'],
    disclaimer: 'All published information corresponds to an ongoing investigation.',
    rights: '© 2026 Periodismo para todos',
  },
}

export const dictionaries = { es, en }
export type Language = keyof typeof dictionaries
